import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();


  export const createDriver = async (data) => {
    try {
      const response = await api.create(`/auth/register`, data);
      return response;
    } catch (error) {
      console.error("Erreur lors de l'appel à l'API:", error);
      throw error;
    }
  };
  export const getDrivers = async () => {
      try {
        const response = await api.get(`/users/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };
 

  export const getDriverById = async (id) => {
      try {
        const response = await api.get(`/users/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getOldDriverVeh = async (id) => {
      try {
        const response = await api.get(`/history/vehicles/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getOldVehicle = async (id) => {
      try {
        const response = await api.get(`/history/users/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateDriver = async ( id, data) => {
      try {
        const response = await axios.patch(`/users/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteDriver = async (id) => {
    try {
        const response = await api.delete(`/users/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
